module.exports = __webpack_public_path__ + "img/logo-header-white.b32dfa0a.png";